import React, { forwardRef, useEffect, useState } from 'react';

interface CategoryProps {
	activeCategory: number;
	setActiveCategory: (category: any) => void;
	ref: React.RefObject<any>;
}

const Category = forwardRef<HTMLDivElement, CategoryProps>(({ activeCategory, setActiveCategory }, ref) => {
	const [category, setCategory] = useState<number>(0);
	const [isInternalChange, setIsInternalChange] = useState(false);
	
	const categories = [
		{
			id: "01",
			name: "Project Reviews",
			classNm: "projectReviewsComponent"
		},
		{
			id: "02",
			name: "Timeline",
			classNm: "platformProjects"
		},
		{
			id: "03",
			name: "Tasker",
			classNm: "platformProjects"
		},
		{
			id: "04",
			name: "Feed",
			classNm: "platformProjects"
		},
		{
			id: "05",
			name: "Degen Calls",
			classNm: "platformProjects"
		},
		{
			id: "06",
			name: "Aggregator",
			classNm: "platformProjects"
		},
	];
	
	const scrollToCategory = (newIndex: number) => {
		setActiveCategory(newIndex);
	}
	
	useEffect(() => {
		if (activeCategory !== category && !isInternalChange) {
			setCategory(activeCategory);
			scrollToCategory(activeCategory);
		}
		setIsInternalChange(false);
	}, [activeCategory]);
	
	useEffect(() => {
		if (category !== null && category !== activeCategory) {
			scrollToCategory(category);
		}
	}, [category]);
	
	return (
		<div className="projectCategory" ref={ref}>
			<div className="projectCategory__content">
				{categories.map((item, index) => (
					<button
						key={index}
						className={`projectCategory__content_item ${
							category === index ? 'active' : ''
						}
						${
							index > category ? 'after-active' : ''
						}
						`}
						onClick={(event) => {
							setIsInternalChange(true);
							setCategory(index);
							
						}}
					>
						<span className={`projectCategory__content_item_num ${category === index ? 'active' : ''}`}>{item.id}</span>
						<span>{item.name}</span>
					</button>
				))}
			</div>
		</div>
	);
});

export default Category;